import { useSelector } from "react-redux";
import IconButton from "../IconButton";
import { VolumeButton } from "../Player/VolumeButton/VolumeButton";
import { LikeAndDislikeWrapper, SecondaryActions } from "./styled";

import { DetailInfoIcon } from "../DetailInfoIcon/DetailInfoIcon";
import {
  selectCurrentContent,
  selectCurrentEntity,
} from "../../redux/selectors/playerSelector";
import FooterPlayerRatingActions from "./FooterPlayerRatingActions";

import { SpeedUpButton } from "../SpeedUpButton";
import { useOpenDrawerTrack } from "../../hooks/useOpenDrawerTrack";

export const FooterPlayerSecondaryActions = () => {
  const currentContent = useSelector(selectCurrentContent);
  const currentEntity = useSelector(selectCurrentEntity);

  const isRelease = currentEntity === "release";

  const openDrawer = useOpenDrawerTrack();

  return (
    <SecondaryActions>
      <LikeAndDislikeWrapper>
        <FooterPlayerRatingActions
          isRelease={isRelease}
          rating={currentContent["user_rating"]}
          trackId={currentContent?.id}
          isLike
        />
        <FooterPlayerRatingActions
          isRelease={isRelease}
          rating={currentContent["user_rating"]}
          trackId={currentContent?.id}
        />
      </LikeAndDislikeWrapper>
      {isRelease && !currentContent.isLive && <SpeedUpButton />}
      <VolumeButton />

      {/* TODO: Пока что убираем это */}
      {/* {isRelease && !currentContent.isLive && (
        <IconButton onClick={openTextHandler} title="Транскрипция">
          <TextIcon />
        </IconButton>
      )} */}
      <IconButton onClick={openDrawer} title="Подробнее">
        <DetailInfoIcon />
      </IconButton>
    </SecondaryActions>
  );
};
